import script from "./RecentProjects.vue?vue&type=script&setup=true&lang=js"
export * from "./RecentProjects.vue?vue&type=script&setup=true&lang=js"

import "./RecentProjects.vue?vue&type=style&index=0&id=28f9a2d3&scoped=true&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_typescript@4.9.5__webpack@5.97.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28f9a2d3"]])

export default __exports__